import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { ListItem, QualityControlRoad, RepositoryModal } from '../../../shared'
import { RoadComponent } from './road.component'

@Component({
    templateUrl: './road-modal.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule],
})
export class RoadModalComponent extends RepositoryModal<QualityControlRoad> implements OnInit {
    supplierOptions: ListItem<number | null>[] = []
    testingAgencyOptions: ListItem<number | null>[] = []
    subContractorOptions: ListItem<number | null>[] = []

    ngOnInit() {
        const parentComponent = this.editOptions.initializeParams as RoadComponent

        // Build supplier options (aggregate vendors)
        this.supplierOptions = []
        this.supplierOptions.push(new ListItem<number | null>(null, 'Select a Supplier'))
        parentComponent.aggregateVendors.forEach(x => {
            this.supplierOptions.push(new ListItem<number | null>(x.id, x.name))
        })

        // Build testing agency and sub contractor options (all vendors including VanCon), sorted alphabetically by name
        const allVendorsSorted = [...parentComponent.allVendors].sort((a, b) => (a.name || '').localeCompare(b.name || ''))
        this.testingAgencyOptions = []
        this.testingAgencyOptions.push(new ListItem<number | null>(null, 'Select a Testing Agency'))
        allVendorsSorted.forEach(x => {
            this.testingAgencyOptions.push(new ListItem<number | null>(x.id, x.name))
        })

        this.subContractorOptions = []
        this.subContractorOptions.push(new ListItem<number | null>(null, 'Select a Sub Contractor'))
        allVendorsSorted.forEach(x => {
            this.subContractorOptions.push(new ListItem<number | null>(x.id, x.name))
        })

        if (this.isAdding) {
            // Set default job from parent
            this.target.job = parentComponent.selectedJob()
        }
    }

    protected onBeforeSave(): boolean {
        if (!this.target.job) {
            this.services.notification.warning('Job is required')
            return false
        }
        return true
    }
}
